import axios from 'axios';

export default function queryFacet(
  requestedFacet,
  { manufacturer, type, size, details, locale }
) {
  // we are using a post request with json body, because the API from schunk might provide chars like | that we would use in getter --> causes errors.
  const qParamsData = {};
  qParamsData.requestedFacet = requestedFacet;
  qParamsData.manufacturer = manufacturer ? manufacturer : '';
  qParamsData.facetType = type ? type : '';
  qParamsData.facetSize = size ? size : '';
  qParamsData.facetDetails = details ? details : '';
  qParamsData.locale = locale;

  return axios.post(
    `${process.env.REACT_APP_BACKEND_BASE_URL}/api/facetSearch?`,
    qParamsData
  );
}



// WEBPACK FOOTER //
// ./src/utils/queryFacet.js